import React from "react";
import cn from "classnames";
import { AlarmProfileCard } from "../alarm-profile-card/alarm-profile-card";
import styles from "./alarm-profiles-cards-wrapper.module.scss";
import { AlarmProfile } from "@src/cloud-connect/alarms/entities/alarm-profile";
import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux";

interface AlarmProfilesCardsWrapperProps {
  alarmProfiles: AlarmProfile[];
  activateProfile: (id: string) => void;
}

const cssClassName = "alarm-profiles-cards-wrapper";

export const AlarmProfilesCardsWrapper = ({
  alarmProfiles,
  activateProfile,
}: AlarmProfilesCardsWrapperProps) => {
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const deactivateProfiles = (permissions) => {
    return permissions.includes("manage-condition-monitoring") ? false : true;
  };

  return (
    <div
      className={cn(styles[cssClassName], {
        [styles[`${cssClassName}--deactivated`]]: deactivateProfiles(
          authContext?.permissions,
        ),
      })}
    >
      {alarmProfiles &&
        alarmProfiles.map((profile) => (
          <AlarmProfileCard
            key={profile.getId()}
            alarmProfile={profile}
            activateProfile={activateProfile}
          />
        ))}
    </div>
  );
};
